import * as firebase from 'firebase/app'

// import all firebase plugins that will be used by our app here
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'

import config from '../firebase.config'

// Init firebase with app config
firebase.initializeApp(config)

// Init auth
export const auth = firebase.auth()

// Init firestore
export const db = firebase.firestore()

// Init functions
export const functions = firebase.functions()

// Init storage
export const storage = firebase.storage()

export const Timestamp = firebase.firestore.Timestamp



// WEBPACK FOOTER //
// ./src/firebase/index.js